export interface Contact {
  id?: number;
  firstName: string;
  lastName: string;
  fullName?: string;
  company?: any;
  companyName?: string;
  title?: string;
  note?: string;
  emails?: {
    [key: string]: string;
  };
  phoneNumbers?: {
    [key: string]: string;
  };
  address1?: string;
  address2?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  timezone?: string;
  birthday?: any;
  photo?: any | null;
  color?: string;
  companies?: any[];
}

export interface MinimalContact {
  firstName: string;
  lastName: string;
}

export const contactFields = [
  'id',
  'first_name',
  'last_name',
  'company',
  'companies',
  'title',
  'note',
  'emails',
  'phone_numbers',
  'address1',
  'address2',
  'city',
  'postal_code',
  'state',
  'timezone',
  'birthday',
  'photo',
  'color',
];

export const minFields = [
  'id',
  'first_name',
  'last_name',
  'photo',
  'emails',
  'phone_numbers',
  'color',
];
